module.exports = {
    digitalPay: {
        creditCardGenericIcon: 'card', // Maps to the generic card icon image
        giftCardNumberLength: 19,
        giftCardPinLength: 4,
        iframeTimeoutInMilliseconds: 30000,
        inlineCvvIframeSpinnerDelayInMilliseconds: 500,
        inlineCvvIframeTimeoutInMilliseconds: 20000,
        formFocusOutTimeoutMilliseconds: 500,
        transactionHistoryContent: 'Review and track your financial transactions related to online orders you\'ve made with Woolworths.',
        paymentMethodsContent: 'Securely save additional and manage existing payment methods that you can use with your Woolworths account to quickly make payments during checkout.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay.js